import { Autocomplete, Box, TextField } from '@mui/material';
import { SyntheticEvent, useState } from 'react';

export type MenuProps = {
  selectedCustomView: string;
  customTabs: string[];
  onSelectView: (name: string) => void;
};

export const Menu = ({ customTabs, onSelectView, selectedCustomView }: MenuProps) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleCustomTabChange = (event: SyntheticEvent<Element, Event>, value: string) => {
    if (value) onSelectView(value);
  };

  return (
    <>
      <Autocomplete
        inputValue={searchQuery}
        onInputChange={(e, val: string) => setSearchQuery(val)}
        disableClearable
        onChange={handleCustomTabChange}
        options={customTabs}
        value={selectedCustomView}
        sx={{ padding: 1, color: 'rgb(107 114 128)', fontSize: '.8rem', width: '12rem' }}
        renderInput={(params) => (
          <TextField
            sx={{ width: '100%', fontSize: '.8rem' }}
            {...params}
            variant="standard"
            placeholder="My Views"
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
              style: {
                fontSize: '.8rem',
                color: 'black',
                fontWeight: 500
              }
            }}
          />
        )}
        renderOption={(props, option, { selected }) => (
          <Box
            component="li"
            {...props}
            key={option}
            sx={{
              backgroundColor: selected ? 'rgba(0, 0, 255, 0.1)' : 'inherit',
              fontWeight: selected ? 'bold' : 'normal'
            }}>
            {option}
          </Box>
        )}
      />
    </>
  );
};
